import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.PMIS_SERVER_PREFIX}/report`;
const endpoints = {
    // PARTNER PROGRAM Endpoint Start
    getPFSDLIoneMISList: () => `${RESOURCE_ENDPOINT}/pfs-mis`,
    getPFSDetailReport: () => `${RESOURCE_ENDPOINT}/pfs-detail`,
    getAreaUnderFruitsVegetableswithGAPCertificationDetailReport: () => `${RESOURCE_ENDPOINT}/fruit-vegetable-gap-certificate-one-three-detail`,
    getPartnerImplementationTrackerReport: () => `${RESOURCE_ENDPOINT}/partner-implementation-tracker`,
    getNewRiceVareityDLRTwoThreeDetailReport: () => `${RESOURCE_ENDPOINT}/new-rice-variety-two-three-detail`,
    getDemoMISList: () => `${RESOURCE_ENDPOINT}/demo-mis`,
    getDemoDemandReport: () => `${RESOURCE_ENDPOINT}/demo-demand`,
    getDemonstrationDemandProposalReport: () => `${RESOURCE_ENDPOINT}/demonstration-demand-proposal`,
    getDemoSeedDemandReport: () => `${RESOURCE_ENDPOINT}/demo-seed-demand`,
    getAgricultureDemonstrationList: () => `${RESOURCE_ENDPOINT}/agriculture-demonstration-dlr-five`,
    getTrainingList: () => `${RESOURCE_ENDPOINT}/training`,
    getRiceSeedProductionDLRTwoTwoReport: () => `${RESOURCE_ENDPOINT}/rice-seed-production-dlr-two-two`,
    getRiceSeedProductionDLRTwoTwoDetailReport: () => `${RESOURCE_ENDPOINT}/rice-seed-production-dlr-two-two-detail`,
    getRiceSeedProductionDLRTwoTwoSummaryReport: () => `${RESOURCE_ENDPOINT}/rice-seed-production-dlr-two-two-summary`,
    getNewRiceVarietyDLRTwoThreeReport: () => `${RESOURCE_ENDPOINT}/new-rice-variety-two-three`,
    getNonRiceVareityDLRThreeThreeDetailReport: () => `${RESOURCE_ENDPOINT}/non-rice-variety-three-three-detail`,
    getNonRiceSeedProductionDLRThreeTwoReport: () => `${RESOURCE_ENDPOINT}/non-rice-seed-production-dlr-three-two`,
    getNonRiceSeedProductionDLRThreeTwoDetailReport: () => `${RESOURCE_ENDPOINT}/non-rice-seed-production-dlr-three-two-detail`,
    getNonRiceSeedProductionDLRThreeTwoSummaryReport: () => `${RESOURCE_ENDPOINT}/non-rice-seed-production-dlr-three-two-summary`,
    getNonRiceVarietyDLRThreeThreeReport: () => `${RESOURCE_ENDPOINT}/non-rice-variety-dlr-three-three`,
    getGAPCertifiedFruitVegAreaReport: () => `${RESOURCE_ENDPOINT}/fruit-vegetable-gap-certificate-one-three`,
    getIrrigationDLRFourTwoReport: () => `${RESOURCE_ENDPOINT}/irrigation-dlr-four-two`,
    getIrrigationDLRFourTwoSummaryReport: () => `${RESOURCE_ENDPOINT}/irrigation-dlr-four-two-summary`,
    getIrrigationDLRFourTwoDetailReport: () => `${RESOURCE_ENDPOINT}/irrigation-dlr-four-two-detail`,
     getLocationwiseSummaryList: () => `${RESOURCE_ENDPOINT}/locationwise-summary`,
    // PARTNER PROGRAM Endpoint End
};

export default class PmisReportApi {
    // PARTNER PROGRAM Endpoint Start
    public getPFSDLIoneMISList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPFSDLIoneMISList();
        return HttpService.post(url, payload, params, headers);
    };

     public getDemoMISList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getDemoMISList();
        return HttpService.post(url, payload, params, headers);
    };

    public getDemoDemandReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getDemoDemandReport();
        return HttpService.post(url, payload, params, headers);
    };

    public getDemonstrationDemandProposalReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getDemonstrationDemandProposalReport();
        return HttpService.post(url, payload, params, headers);
    };

    public getDemoSeedDemandReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getDemoSeedDemandReport();
        return HttpService.post(url, payload, params, headers);
    };


    
      public getPFSDetailReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPFSDetailReport();
        return HttpService.post(url, payload, params, headers);
    };

      public getAreaUnderFruitsVegetableswithGAPCertificationDetailReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAreaUnderFruitsVegetableswithGAPCertificationDetailReport();
        return HttpService.post(url, payload, params, headers);
    };
      public getPartnerImplementationTrackerReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getPartnerImplementationTrackerReport();
        return HttpService.post(url, payload, params, headers);
    };

      public getNewRiceVareityDLRTwoThreeDetailReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNewRiceVareityDLRTwoThreeDetailReport();
        return HttpService.post(url, payload, params, headers);
    };

      public getNonRiceVareityDLRThreeThreeDetailReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNonRiceVareityDLRThreeThreeDetailReport();
        return HttpService.post(url, payload, params, headers);
    };



    public getAgricultureDemonstrationList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getAgricultureDemonstrationList();
        return HttpService.post(url, payload, params, headers);
    };

    public getTrainingList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getTrainingList();
        return HttpService.post(url, payload, params, headers);
    };

    public getRiceSeedProductionDLRTwoTwoReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getRiceSeedProductionDLRTwoTwoReport();
        return HttpService.get(url, params, headers);
    };

    public getRiceSeedProductionDLRTwoTwoDetailReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getRiceSeedProductionDLRTwoTwoDetailReport();
        return HttpService.post(url, payload, params, headers);
    };

    public getRiceSeedProductionDLRTwoTwoSummaryReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getRiceSeedProductionDLRTwoTwoSummaryReport();
        return HttpService.get(url, params, headers);
    };

    public getNonRiceSeedProductionDLRThreeTwoDetailReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNonRiceSeedProductionDLRThreeTwoDetailReport();
        return HttpService.post(url, payload, params, headers);
    };

    public getNewRiceVarietyDLRTwoThreeReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNewRiceVarietyDLRTwoThreeReport();
        return HttpService.get(url, params, headers);
    };

    public getNonRiceSeedProductionDLRThreeTwoReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNonRiceSeedProductionDLRThreeTwoReport();
        return HttpService.get(url, params, headers);
    };

    public getNonRiceSeedProductionDLRThreeTwoSummaryReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNonRiceSeedProductionDLRThreeTwoSummaryReport();
        return HttpService.get(url, params, headers);
    };

    public getNonRiceVarietyDLRThreeThreeReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getNonRiceVarietyDLRThreeThreeReport();
        return HttpService.get(url, params, headers);
    };

    public getGAPCertifiedFruitVegAreaReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getGAPCertifiedFruitVegAreaReport();
        return HttpService.get(url, params, headers);
    };

    public getIrrigationDLRFourTwoReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getIrrigationDLRFourTwoReport();
        return HttpService.get(url, params, headers);
    };

    public getIrrigationDLRFourTwoSummaryReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getIrrigationDLRFourTwoSummaryReport();
        return HttpService.get(url, params, headers);
    };

    
    public getLocationwiseSummaryList = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationwiseSummaryList();
        return HttpService.post(url, payload, params, headers);
    };

      
  public getIrrigationDLRFourTwoDetailReport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getIrrigationDLRFourTwoDetailReport();
        return HttpService.post(url, payload, params, headers);
    };

     public startExport = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = `${CONSTANT_CONFIG.PMIS_SERVER_PREFIX}/export`;
        return HttpService.post(url, payload, params, headers);
    };

    public exportStatus = (id: number): AxiosPromise<any> => {
        const url = `${CONSTANT_CONFIG.PMIS_SERVER_PREFIX}/export/status/${id}`;
        return HttpService.get(url);
    };
}
